import { getPrice } from '@fourthwall/utils/dist/common'
import { pluralize } from '@fourthwall/utils/dist/string'

import type { SelectedItem } from '../SelectItems.types'

export const getSelectModalMessage = (selectedItems: SelectedItem[]): string => {
  const totalQuantity = selectedItems.reduce((total, { quantity }) => total + Number(quantity), 0)
  const totalPrice = selectedItems.reduce((total, { price, quantity }) => {
    if (!price) {
      return total
    }

    return total + price.value * parseInt(quantity)
  }, 0)

  const itemsText = pluralize(totalQuantity, 'item')
  const totalPriceText = !totalQuantity ? '' : ` (${getPrice(totalPrice)} total)`

  return `${totalQuantity} ${itemsText} selected${totalPriceText}`
}
